const fileDownload = require('react-file-download');

const convertToCSV = (data) => {
  const keys = Object.keys(data[0]);

  // Build header
  let result = keys.join("\t") + "\n";

  // Add the rows
  data.forEach(function(obj){
    keys.forEach(function(k, ix){
      if (ix) result += "\t";
      result += obj[k];
    });
    result += "\n";
  });

  return result;
};

export default function downloadCSV(fileName, data) {
  if (data && data.length) {
    fileDownload(convertToCSV(data), fileName);
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/libs/donwloadCSV.js